import Pusher from "pusher-js";
import constant from "../constant";

let pusher = null;
let channel = null;
let privateChannel = null;

const pusherPlugin = {
  install(Vue) {
    Vue.prototype.$pusher = {
      /**
       * Initialize Pusher connection
       * @param {string} userId - Optional user ID for private channels
       */
      init(userId = null) {
        if (pusher) {
          this.disconnect();
        }

        const pusherKey =
          process.env.VUE_APP_PUSHER_APP_KEY || "4ac9a3e6e21b0f9b2927";
        const pusherCluster = process.env.VUE_APP_PUSHER_CLUSTER || "mt1";

        const tokenValue = localStorage.getItem(constant.authToken);
        const token = tokenValue ? tokenValue.replaceAll('"', "") : "";

        pusher = new Pusher(pusherKey, {
          cluster: pusherCluster,
          encrypted: true,
          authEndpoint: `${constant.url}broadcasting/auth`,
          auth: {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          },
        });

        // Subscribe to public channel
        channel = pusher.subscribe("pda-notifications");

        // Subscribe to private channel if userId is provided
        if (userId) {
          privateChannel = pusher.subscribe(
            `private-pda-notifications.${userId}`
          );
        }

        // Connection state callbacks
        pusher.connection.bind("connected", () => {
          console.log("Pusher connected");
        });

        pusher.connection.bind("disconnected", () => {
          console.log("Pusher disconnected");
        });

        pusher.connection.bind("error", (err) => {
          console.error("Pusher error:", err);
        });

        return pusher;
      },

      /**
       * Listen to notifications on public channel
       * @param {Function} callback - Callback function to handle notifications
       */
      listen(callback) {
        if (!channel) {
          console.error("Pusher not initialized. Call init() first.");
          return;
        }

        channel.bind("notification", (data) => {
          if (callback) {
            callback(data);
          }
        });
      },

      /**
       * Listen to notifications on private channel
       * @param {Function} callback - Callback function to handle notifications
       */
      listenPrivate(callback) {
        if (!privateChannel) {
          console.error(
            "Private channel not initialized. Call init(userId) first."
          );
          return;
        }

        privateChannel.bind("notification", (data) => {
          if (callback) {
            callback(data);
          }
        });
      },

      /**
       * Unbind all event listeners
       */
      unbind() {
        if (channel) {
          channel.unbind("notification");
        }
        if (privateChannel) {
          privateChannel.unbind("notification");
        }
      },

      /**
       * Disconnect Pusher
       */
      disconnect() {
        if (pusher) {
          this.unbind();
          pusher.disconnect();
          pusher = null;
          channel = null;
          privateChannel = null;
        }
      },

      /**
       * Get Pusher instance
       */
      getInstance() {
        return pusher;
      },
    };
  },
};

export default pusherPlugin;
